export default {
  /* dashboard input name */
  setDashboardNameToCreate: (state, dashboardNameToCreate) =>
    (state.dashboardNameToCreate = dashboardNameToCreate),

  /* dashboard */
  setDashboard: (state, dashboard) => (state.dashboard = dashboard),
  addDashboard: (state, dashboard) => (state.dashboard = dashboard),
  // addDashboard: (state, dashboard) => state.dashboard.push(dashboard),
  removeDashboardById: (state, dashboardId) => {
    const index = state.dashboard.findIndex(
      dashboard => dashboard.id === dashboardId
    )
    state.dashboard.splice(index, 1)
  },

  /* dashboard deletion */
  addDashboardDeletionPending: (state, dashboardId) =>
    state.dashboardDeletionPending.push(dashboardId),
  removeDashboardDeletionPending: (state, dashboardId) => {
    const index = state.dashboard.findIndex(
      dashboard => dashboard.id === dashboardId
    )
    state.dashboardDeletionPending.splice(index, 1)
  },

  /* dashboard creation */
  setDashboardCreationPending: (state, value) =>
    (state.dashboardCreationPending = value)
}
